module.exports = __webpack_public_path__ + "images/healthInsurance3e2e52283f86b7a93aab9f8b2a24ec57.jpg";